// Port of api/fuel/app/classes/insights/worth/plays.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function featuredGame(raw) {
	var games = raw ? raw.split(',').map(function(id) { return parseInt(id, 10) }).filter(Boolean) : []
	return games.length ? games.sort(function(a, b) { return a - b })[0] : 0
}

export default Segment.extend({
	name: 'plays',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['plays'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var band = parseInt(vars.band, 10) || 0
		var mode = (filter && filter.plays) ? filter.plays : 'total'
		var plays = [
			{ p: '0', g: 0, w: 0, f: 0, i: 1 },
			{ p: '1', g: 0, w: 0, f: 0, i: 2 },
			{ p: '2', g: 0, w: 0, f: 0, i: 3 },
			{ p: '3', g: 0, w: 0, f: 0, i: 4 },
			{ p: '4', g: 0, w: 0, f: 0, i: 5 },
			{ p: '5', g: 0, w: 0, f: 0, i: 6 },
			{ p: '6-10', g: 0, w: 0, f: 0, i: 7 },
			{ p: '11-15', g: 0, w: 0, f: 0, i: 8 },
			{ p: '16-20', g: 0, w: 0, f: 0, i: 9 },
			{ p: '21+', g: 0, w: 0, f: 0, i: 10 }
		]
		var min = 0
		var max = 0

		if (detail) {
			if (band <= 6) {
				min = band - 1
				max = band - 1
			} else if (band === 7) {
				min = 6
				max = 10
			} else if (band === 8) {
				min = 11
				max = 15
			} else if (band === 9) {
				min = 16
				max = 20
			} else {
				min = 21
				max = false
			}

			var detailRaw = Util.queryFast(
				'SELECT g.game_id AS g, COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0) AS w' +
				' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
				' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id' +
				' WHERE c.user_id = ' + owner.get_id() +
				' AND c.collection_own = 1' +
				' AND g.game_worth_value > 0' +
				' AND c.collection_expansion = 0' +
				' AND c.collection_plays >= ' + min +
				(max !== false ? (' AND c.collection_plays <= ' + max) : '') +
				' ORDER BY w DESC'
			)
			var games = []

			for (var i = 0; i < detailRaw.length; i++) {
				var gameId = parseInt(detailRaw[i].g, 10)
				this._references.games.push(gameId)
				games.push({
					id: gameId,
					worth: Math.round(parseFloat(detailRaw[i].w) || 0)
				})
			}

			return {
				games: games
			}
		}

		var raw = Util.queryFast(
			'SELECT GROUP_CONCAT(DISTINCT(c.game_id)) AS i, c.collection_plays AS p,' +
			' COUNT(DISTINCT(c.game_id)) AS g,' +
			' SUM(COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0)) AS w' +
			' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
			' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id' +
			' WHERE c.user_id = ' + owner.get_id() +
			' AND c.collection_own = 1' +
			' AND g.game_worth_value > 0' +
			' AND c.collection_expansion = 0' +
			' GROUP BY c.collection_plays ORDER BY c.collection_plays'
		)

		for (var j = 0; j < raw.length; j++) {
			var item = raw[j]
			var totalWorth = parseFloat(item.w) || 0
			var playCount = parseInt(item.p, 10) || 0
			if (!totalWorth) continue

			var playIndex = 0
			if (playCount <= 5) playIndex = playCount
			else if (playCount >= 6 && playCount <= 10) playIndex = 6
			else if (playCount >= 11 && playCount <= 15) playIndex = 7
			else if (playCount >= 16 && playCount <= 20) playIndex = 8
			else if (playCount >= 21) playIndex = 9

			plays[playIndex].g += parseInt(item.g, 10) || 0
			plays[playIndex].w += totalWorth
			plays[playIndex].f = featuredGame(item.i)
		}

		if (mode === 'average') {
			for (var p = 0; p < plays.length; p++) {
				if (plays[p].w) plays[p].w = plays[p].w / plays[p].g
			}
		}

		return {
			plays: plays
		}
	}
})
